module.exports = __webpack_public_path__ + "media/effects-11.4a3d495e.webm";